import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  tradePlanId: string;
};

export const PnLComponent = ({ tradePlanId }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const positionId = tradePlanStore.tradePlans[tradePlanId].positionId;
  const unrealizedPnl =
    tradePlanStore.positions.tradeUnafraid[positionId]?.uPnlAtBidAsk ?? 0;
  const realizedPnl =
    tradePlanStore.positions.tradeUnafraid[positionId]?.realizedPnl ?? 0;
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          uPnL:{' '}
        </Body3>
        <Body3
          color={
            Number(unrealizedPnl) > 0
              ? colors.green
              : Number(unrealizedPnl) < 0
              ? colors.red
              : colors.lightGrey
          }
          fontWeight={500}
          margin="0 5px 0 0"
        >
          ${ApplyRounding(Math.abs(unrealizedPnl), 2)}
        </Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          rPnL:{' '}
        </Body3>
        <Body3
          color={
            Number(realizedPnl) > 0
              ? colors.green
              : Number(realizedPnl) < 0
              ? colors.red
              : colors.lightGrey
          }
          fontWeight={500}
        >
          ${ApplyRounding(Math.abs(realizedPnl), 2)}
        </Body3>
      </div>
    </div>
  );
};
